<template>
  <v-container fluid>
    <v-skeleton-loader v-if="!raw_messages" class="mx-auto" type="table"></v-skeleton-loader>
    <DataTableVT
      v-else
      :headers="page_content.messages_table"
      sort_by="TimestampISO"
      :items_list="raw_messages"
      :no_search="no_search"
      :isTransitionOn="false"
    />
  </v-container>
</template>

<script>
import { axios_get } from "../services/vt_service";
import { scv } from "../services/powerdata";
import { content } from "../../config/scavenger.js";
import { scavenger_grpc_services } from "../services/ScavengerServices";

import DataTableVT from "../components/DataTableVT";

export default {
  name: "ScavengerAssetMessages",
  props: {
    device_id: String,
    as_of: String,
    start_date: String,
    end_date: String,
    realtime_data: Array,
  },
  components: {
    DataTableVT,
  },
  watch: {
    as_of: function () {
      this.raw_messages = null;
      this.getDeviceRawData();
    },
    realtime_data: function (newVal, oldVal) {
      if (newVal && newVal != oldVal) {
        // console.log("changed mesages data", newVal);
        if (!this.raw_messages) return (this.raw_messages = newVal);
        return this.raw_messages[0].seqNo != newVal[0].seqNo ? this.raw_messages.splice(0, 0, newVal[0]) : null;
      }
    },
  },
  data: function () {
    return {
      page_content: null,
      raw_messages: null,
      no_search: true,
      overlay_type: null,
    };
  },
  created() {
    this.page_content = content;
    this.getDeviceRawData();
    // console.log("messages data ", this.raw_data);
  },
  methods: {
    async getDeviceRawData(parameters) {
      this.dialog = false;
      this.overlay_type = "";
      this.network_error = false;
      let params =
        this.as_of != this.today_timestamp
          ? {
              start_date: this.$timestampToEpoch(new Date(new Date(this.as_of).getTime() + 60 * 60 * 24 * 1000 - 1)),
            }
          : null;
      if (parameters) params = parameters;
      // axios_get(scv.get_device_raw_data, { id: this.device_id }, params).then((response) => {
      //   if (!this.raw_messages) return (this.raw_messages = response);
      //   return this.raw_messages[0].seqNo != response[0].seqNo ? this.raw_messages.splice(0, 0, response[0]) : null;
      // });
      scavenger_grpc_services.GetMinListData(this.device_id, params).then((response) => {
        if (!this.raw_messages) return (this.raw_messages = response);
        return this.raw_messages[0].seqNo != response[0].seqNo ? this.raw_messages.splice(0, 0, response[0]) : null;
      });
    },
  },
  computed: {
    today_timestamp() {
      return new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10);
    },
  },
};
</script>
